import type {ReactNode} from 'react';
import {useQuery} from '@tanstack/react-query';
import {Navigate} from 'react-router';
import {meQueryOptions} from '../api/auth';
import {FullScreenLoader} from './FullScreenLoader';

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({children}: Props) {
  const {data, isPending, isError} = useQuery(meQueryOptions);

  if (isPending) {
    return <FullScreenLoader />;
  }
  if (isError || !data) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
